import React from 'react';
import styled from 'styled-components';
import agriImg from '../assets/images/aaas.jpg';

const PageContainer = styled.div`
  padding-top: 80px;
  max-width: 900px;
  margin: 0 auto;
`;
const HeroImage = styled.div`
  width: 100%;
  height: 320px;
  background: url(${agriImg}) center center/cover no-repeat;
  border-radius: 12px;
  margin-bottom: 2.5rem;
  box-shadow: 0 10px 30px rgba(0,0,0,0.07);
`;
const Title = styled.h1`
  font-size: 2.3rem;
  font-weight: 700;
  margin: 2rem 0 2.5rem 0;
  color: #222;
  text-align: center;
`;
const Section = styled.section`
  margin-bottom: 2.5rem;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  padding: 2rem 2.5rem;
`;
const SectionTitle = styled.h2`
  font-size: 1.4rem;
  color: var(--primary);
  margin-bottom: 1rem;
  font-weight: 600;
`;
const Paragraph = styled.p`
  color: #333;
  line-height: 1.7;
  margin-bottom: 1.2rem;
`;
const ServiceList = styled.ul`
  margin-top: 0.5rem;
  margin-bottom: 1.2rem;
  list-style: disc inside;
  padding-left: 1.2rem;
`;
const ServiceItem = styled.li`
  color: #333;
  font-weight: 500;
  margin-bottom: 0.5rem;
`;
const TagList = styled.ul`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: 1rem;
  padding: 0;
  list-style: none;
`;
const Tag = styled.li`
  background: var(--primary);
  color: #fff;
  border-radius: 16px;
  font-size: 0.95rem;
  font-weight: 600;
  padding: 0.4rem 1.1rem;
  margin-bottom: 0.5rem;
`;

const UseCaseAgriFood = () => (
  <PageContainer>
    <HeroImage />
    <Title>Digitization Roadmap for Agri-Food Certification & Traceability</Title>
    <Section>
      <SectionTitle>The Situation</SectionTitle>
      <Paragraph>
        Agri-food exporters face mounting pressure to prove origin, sustainability, and quality, often relying on manual paperwork for certifications, customs, and logistics. These challenges result in delayed shipments, failed certifications, manual rework, and poor visibility across the supply chain.
      </Paragraph>
    </Section>
    <Section>
      <SectionTitle>How Platform0 Would Help</SectionTitle>
      <Paragraph>
        Platform0 would architect a digital backbone for certification and traceability, tailored to agriculture-specific challenges:
      </Paragraph>
      <ServiceList>
        <ServiceItem>Automated document processing for sustainability, organic, and food safety certification</ServiceItem>
        <ServiceItem>Composable workflow platform integrating data from growers, inspectors, logistics, and regulators</ServiceItem>
        <ServiceItem>Cloud-native infrastructure to centralize and secure critical data</ServiceItem>
        <ServiceItem>Real-time dashboards for customers and auditors to track product history from farm to port</ServiceItem>
      </ServiceList>
    </Section>
    <Section>
      <SectionTitle>The Expected Outcomes</SectionTitle>
      <ServiceList>
        <ServiceItem>Reduce audit prep time by 60%</ServiceItem>
        <ServiceItem>Improve cross-border trust and reduce clearance time</ServiceItem>
        <ServiceItem>Scale operations without adding manual overhead</ServiceItem>
        <ServiceItem>Demonstrate compliance with evolving ESG and food safety standards</ServiceItem>
      </ServiceList>
    </Section>
    <Section>
      <SectionTitle>Relevant Platform0 Services</SectionTitle>
      <TagList>
        <Tag>Digital Transformation</Tag>
        <Tag>Cloud Solutions</Tag>
        <Tag>Architecture as a Service</Tag>
      </TagList>
    </Section>
  </PageContainer>
);

export default UseCaseAgriFood;
